import { Directive, ElementRef, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { StyleState } from '@finxone-platform/shared/sys-config-types';

@Directive({
  selector: '[dynamicStyle]',
})
export class DynamicStyleDirective implements OnInit, OnDestroy {
  @Input('dynamicStyle') styles: StyleState = {};

  private styleElement: HTMLStyleElement | null = null;
  private uniqueId: string;

  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.uniqueId = `dynamic-style-${Math.random().toString(36).substr(2, 9)}`;
  }

  ngOnInit() {
    this.applyStyles();
  }

  private applyStyles() {
    const tagName = this.el.nativeElement.tagName.toLowerCase();
    this.el.nativeElement.setAttribute('data-dynamic-id', this.uniqueId);

    const styleString = this.generateStyleString(tagName);
    this.createStyleElement(styleString);
  }
  private generateStyleString(tagName: string): string {
    let styleString = '';

    Object.entries(this.styles).forEach(([state, value]) => {
      const baseSelector = `${tagName}[data-dynamic-id="${this.uniqueId}"]`;
      let stateSelector: string;
      let cssString: string;

      if (typeof value === 'string') {
        stateSelector = state === 'default' ? baseSelector : `${baseSelector}:${state}`;
        cssString = value;
      } else {
        stateSelector = value.selector
          ? `${baseSelector}${value.selector}`
          : state === 'default'
          ? baseSelector
          : `${baseSelector}:${state}`;
        cssString = value.css;
      }

      // Parse the CSS string
      const parsedCss = this.parseCssString(cssString);

      // Apply the parsed CSS to the state selector
      styleString += `${stateSelector} { ${parsedCss} } `;
    });

    return styleString;
  }

  private parseCssString(cssString: string): string {
    // Remove any existing selectors and just keep the CSS properties
    return cssString
      .replace(/[^}]+{/, '')
      .replace('}', '')
      .trim();
  }

  private createStyleElement(styles: string) {
    this.styleElement = this.renderer.createElement('style');
    this.renderer.appendChild(this.styleElement, this.renderer.createText(styles));
    this.renderer.appendChild(document.head, this.styleElement);
  }

  ngOnDestroy() {
    if (this.styleElement) {
      this.renderer.removeChild(document.head, this.styleElement);
    }
  }
}
